import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '../../../../auth/services/auth.service';
import { DashboardFilter } from '../../../models/custom-dashboard.model';
import { UpsaleModalService } from '../../../services/upsale-modal.service';

@Component({
  selector: 'mpro-dashboard-dialog-box',
  templateUrl: './dashboard-dialog-box.component.html',
  styleUrls: ['./dashboard-dialog-box.component.scss']
})
export class DashboardDialogBoxComponent implements OnInit {
  public faLock = faLock;

  @Input() title: string
  @Input() dashboardFilter: DashboardFilter;

  name: string = ""
  inputState: "default" | "error" = "default"

  @Output() save = new EventEmitter()
  @Output() cancel = new EventEmitter()

  constructor(public authService: AuthService, private upsaleModalService: UpsaleModalService) { }

  ngOnInit(): void {
  }

  keyup() {
    this.inputState = "default"
  }

  saveClick() {
    if (!this.authService.isLoggedIn()) {
      this.upsaleModalService.open();
      return;
    }
    if (this.name.length > 12) {
      this.inputState = "error";
      return;
    }

    this.save.emit(this.dashboardFilter);
  }

  cancelClick() {
    this.cancel.emit()
  }
}
